// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__3Pl0J","active":"Modal_active__2fRa_","innerWrapper":"Modal_innerWrapper__1-YD0","inner":"Modal_inner__3AF8b","text":"Modal_text__25J-t"};